import { useMutation, useQueryClient } from '@tanstack/react-query';

import { withError, withInvalidate } from '@/react-tools/react-query';
import { getAllSettledItems } from '@/portainer/helpers/promise-utils';

import { TeamId } from '../types';

import { updateTeam } from './useUpdateTeamMutation';
import { teamQueryKeys } from './query-keys';

interface ApplyPayload {
  teamIds: TeamId[];
  denyPortainerAccess: boolean;
}

/** Sets DenyPortainerAccess on every given team. */
export function useApplyDenyPortainerAccessMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: applyDenyPortainerAccess,
    ...withError('Failed to update team access to Portainer'),
    ...withInvalidate(queryClient, [teamQueryKeys.base()]),
  });
}

async function applyDenyPortainerAccess({
  teamIds,
  denyPortainerAccess,
}: ApplyPayload) {
  // allSettled: every team is attempted, and a partial failure is reported in
  // full rather than only the first rejection.
  const { rejectedItems } = await getAllSettledItems(teamIds, (id) =>
    updateTeam({ id, denyPortainerAccess })
  );

  if (rejectedItems.length > 0) {
    throw new Error(
      `${rejectedItems.length} of ${teamIds.length} teams could not be updated: ${rejectedItems
        .map(({ reason }) => reason)
        .join(', ')}`
    );
  }
}
